import { render } from "./CustomHotelGroup.vue?vue&type=template&id=fd73ff98&scoped=true"
import script from "./CustomHotelGroup.vue?vue&type=script&lang=js"
export * from "./CustomHotelGroup.vue?vue&type=script&lang=js"

import "./CustomHotelGroup.vue?vue&type=style&index=0&id=fd73ff98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd73ff98"]])

export default __exports__